import ImageWithFallback from '@/components/custom-image-with-fallback/image-with-fallback';
import { APP_ASSETS } from '@/constant/assets';
import React from 'react';

const BackgroundSignIn = React.memo(() => {
    return (
        <div className='absolute inset-0 flex select-none items-center justify-center overflow-hidden opacity-90' />
    );
});

BackgroundSignIn.displayName = 'BackgroundSignIn';

export { BackgroundSignIn };
